<template>
  <div class="convey911-deviceName">
    <span class="device device-mac" v-if="deviceName === 'Mac OS'">
      <img
        src="@/assets/images/devices/mac.png"
        alt="avatar"
        class="rounded-circle"
        width="20"
      />
    </span>
    <span class="device device-windows" v-if="deviceName === 'Windows'">
      <img
        src="@/assets/images/devices/windows.png"
        alt="avatar"
        class="rounded-circle"
        width="20"
      />
    </span>
    <span class="device device-chromium" v-if="deviceName === 'Chromium OS'">
      <img
        src="@/assets/images/devices/chromium.png"
        alt="avatar"
        class="rounded-circle"
        width="20"
      />
    </span>
    <span class="device device-linux" v-if="deviceName === 'Linux'">
      <img
        src="@/assets/images/devices/linux-icon.svg"
        alt="avatar"
        class="rounded-circle"
        width="20"
      />
    </span>
    <span class="device device-ubuntu" v-if="deviceName === 'Ubuntu'">
      <img
        src="@/assets/images/devices/ubuntu-logo.png"
        alt="avatar"
        class="rounded-circle"
        width="20"
      />
    </span>
    <span class="device device-android" v-if="deviceName === 'Android'">
      <img
        src="@/assets/images/devices/android.png"
        alt="avatar"
        class="rounded-circle"
        width="20"
      />
    </span>
    <span class="device device-iphone" v-if="deviceName === 'iPhone'">
      <img
        src="@/assets/images/devices/iphone.png"
        alt="avatar"
        class="rounded-circle"
        width="20"
      />
    </span>
  </div>
</template>

<script>
export default {
  name: "DeviceIcons",
  props: {
    deviceName: String,
  },
  data() {
    return {};
  },
};
</script>



<style lang="scss">
.convey911-deviceName {
  & .device {
    background: #d9f4ff;
    display: flex;
    max-width: 30px;
    max-height: 30px;
    padding: 12px;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
  }
  & .device-mac {
    background: #faf2dc;
  }
  & .device-windows {
    background: #d9f4ff;
  }
  & .device-chromium {
    background: #1a73e812;
  }
  & .device-linux {
    background: #faf2dc;
  }
  & .device-ubuntu {
    background: #e64a1930;
  }
  & .device-android {
    background: #efffe0;
  }
  & .device-iphone {
    background: #f7d9ff;
  }
}
</style>